import React, { useRef } from 'react';
import { createGlobalStyle } from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';
import { Testimonial } from './components/Testimonial';
import { CarouselNavigationButton } from '../CarouselNavigationButton';
import { Container } from '../Container';
import { data as testimonials } from '../../data/health-testimonials';
import { Box, BoxProps } from '../../wag-react/next-components/box';
import { Flex } from '../../wag-react/next-components/Flex';
import { Grid } from '../../wag-react/core-components/grid';
const swiperParams = {
  slidesPerView: 1,
  grabCursor: true,
  loop: true,
  loopFillGroupWithBlank: true,
  navigation: {
    nextEl: '.swiper-button-next.testimonials-swiper-button-next',
    prevEl: '.swiper-button-prev.testimonials-swiper-button-prev'
  },
  pagination: {
    clickable: true,
    el: '.swiper-pagination-custom',
    type: 'bullets'
  },
  spaceBetween: 16
} as const;
export type TestimonialsCarouselProps = BoxProps;
SwiperCore.use([Pagination]);

/*
  We can't create a component for the "children" of the <Swiper />
  for some reason with its internal code. Whenever we create
  a component and render it on Swiper's children,
  the CSS classes aren't getting applied.
  In order to work on top of that, we have to iterate here directly
*/

export const TestimonialsCarousel = (props: TestimonialsCarouselProps) => {
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  return <>
      <Container my={['unset', '40px']} width={[1, null, '50%']} mx="unset" {...props} data-sentry-element="Container" data-sentry-source-file="index.tsx">
        <Flex flexDirection="column" overflow="hidden" mx={['initial', 'unset']} position="relative" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
          <Grid gridTemplateColumns={['max-content', 'repeat(2, max-content)']} justifyContent={['center', 'space-between']} order={[2, 1]} my={['unset', '40px']} data-sentry-element="Grid" data-sentry-source-file="index.tsx">
            <Flex alignItems="center" justifyContent="center" my={1} {...{
            className: 'swiper-pagination-custom'
          } as BoxProps} data-sentry-element="Flex" data-sentry-source-file="index.tsx" />
            <Grid gridTemplateColumns={['repeat(2, max-content)']} gridGap="16px" data-sentry-element="Grid" data-sentry-source-file="index.tsx">
              <CarouselNavigationButton variant="prev" iconProps={{
              color: 'champagne',
              fontSize: ['30px', '36px']
            }} data-sentry-element="CarouselNavigationButton" data-sentry-source-file="index.tsx" />
              <CarouselNavigationButton variant="next" iconProps={{
              color: 'champagne',
              fontSize: ['30px', '36px']
            }} data-sentry-element="CarouselNavigationButton" data-sentry-source-file="index.tsx" />
              <Box ref={navigationPrevRef} className="swiper-button-prev testimonials-swiper-button-prev" height="auto" id="swiper-button-prev" left={['8px', 0, '8px']} right="unset" top="72px" position={['absolute', 'unset']} m={0} width="auto" data-sentry-element="Box" data-sentry-source-file="index.tsx" />
              <Box ref={navigationNextRef} className="swiper-button-next testimonials-swiper-button-next" height="auto" id="swiper-button-next" left="unset" right={['8px', 0, '8px']} top="72px" position={['absolute', 'unset']} m={0} width="auto" data-sentry-element="Box" data-sentry-source-file="index.tsx" />
            </Grid>
          </Grid>
          <Box order={[1, 2]} mt={['40px', 'unset']} mb={['24px', 'unset']} px={['48px', 'unset']} data-sentry-element="Box" data-sentry-source-file="index.tsx">
            <Swiper {...swiperParams} data-sentry-element="Swiper" data-sentry-source-file="index.tsx">
              {testimonials.map(({
              name,
              text
            }) => <SwiperSlide key={text}>
                  <Testimonial name={name} text={text} />
                </SwiperSlide>)}
            </Swiper>
          </Box>
        </Flex>
      </Container>
      <SwiperGlobalStyle data-sentry-element="SwiperGlobalStyle" data-sentry-source-file="index.tsx" />
    </>;
};
const SwiperGlobalStyle = createGlobalStyle`
  .swiper-button-prev:after {
    display: none;
  }

  .swiper-button-next:after {
    display: none;
  }

  .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .swiper-pagination-bullet {
    background-color: #FAE7A8;
    opacity: 1;
    height: 12px;
    width: 12px;
  }
  .swiper-pagination-bullet:nth-child(n+2) {
    margin-left: 8px;
  }
  .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background-color: #FFF;
    width: 18px;
    height: 18px;
  }
`;